define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty"
],
    function (lang, TypeConstants, TypeProperty, TagProperty) {
        var hash = {};

        hash[TypeConstants.FOOTER] = lang.mixin({
        }, TypeProperty, TagProperty);
        return hash;
    });

